export default __webpack_public_path__ + "static/media/0.961d1481.jpg";